import { takeEvery, call, all, put, Effect } from 'redux-saga/effects';
import { Actions, getCheckInsFailure, getCheckInsRequest, getCheckInsSuccess } from 'actions/checkInsActions';
import { getThemeHistoryFailure, getThemeHistorySuccess } from 'actions/themeHistoryActions';
import { CheckIn, ThemeHistory } from 'shared/models';
import { toError } from 'shared/util/toError';
import { apiGet } from './apiSagas';

type CheckInsOutput = {
    checkIns: CheckIn[];
    themeHistory: ThemeHistory;
};
export function* getCheckInsRequestWatcher() {
    yield takeEvery(Actions.GET_CHECKINS_REQUEST, getCheckInsSaga);
}

function* getCheckInsSaga(action: ReturnType<typeof getCheckInsRequest>) {
    const deviceId = action.payload;
    const { since } = action.meta || {};
    try {
        const cacheBust = Math.random().toString(28).substring(2);
        const timeStampParam = since ? `&timestamp=${since}` : '' ;
        const { checkIns, themeHistory }: CheckInsOutput = yield call(apiGet, `/api/devices/${deviceId}/check-ins?${cacheBust}${timeStampParam}`);
        const sagaPutActions: Effect[] = [ put(getCheckInsSuccess(checkIns, { deviceId })) ];

        if (checkIns.length) {
            sagaPutActions.push(put(getThemeHistorySuccess(themeHistory, { deviceId })));
        }
        yield all(sagaPutActions);
    }
    catch (e) {
        const err = toError(e);
        yield all([
            put(getCheckInsFailure(err, { deviceId })),
            put(getThemeHistoryFailure(err, { deviceId })),
        ]);
    }
}
